import { useEffect, useState } from 'preact/hooks';
import { route } from 'preact-router';
import { T } from '@/ui/tokens';
import { Spinner } from '@/ui/primitives/Spinner';
import { config } from '@/config';
import { authRepo } from '@/data/repositories/auth-repo';

export function VerifyEmailScreen(props: { token?: string; path?: string }) {
  const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = props.token || new URLSearchParams(window.location.search).get('token') || '';
    if (!token) {
      setStatus('error');
      setMessage('No verification token found.');
      return;
    }

    authRepo.verifyEmail(token)
      .then((res) => {
        setStatus('ok');
        setMessage(res.message ?? 'Email verified successfully.');
      })
      .catch((err: any) => {
        setStatus('error');
        setMessage(err?.message ?? 'Invalid or expired verification token.');
      });
  }, [props.token]);

  return (
    <div style={{
      background: T.bg, height: '100dvh',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '40px 28px', textAlign: 'center',
    }}>
      <div style={{
        width: 56, height: 56, borderRadius: 28,
        background: status === 'ok' ? 'rgba(57,229,140,0.12)'
          : status === 'error' ? 'rgba(255,90,110,0.12)'
          : 'rgba(198,255,61,0.12)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 24,
      }}>
        {status === 'loading' && <Spinner size={24}/>}
        {status === 'ok' && (
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path d="M5 13l4 4L19 7" stroke={T.ok} stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        )}
        {status === 'error' && (
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path d="M6 6l12 12M18 6L6 18" stroke={T.danger} stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        )}
      </div>

      <div style={{
        fontSize: 20, fontWeight: 700, color: T.text,
        marginBottom: 8,
      }}>
        {status === 'loading' ? 'Verifying your email…'
          : status === 'ok' ? 'Email verified!'
          : 'Verification failed'}
      </div>

      {message && (
        <p style={{
          fontSize: 14, color: T.textDim, lineHeight: 1.5,
          margin: '0 0 28px', maxWidth: 300,
        }}>
          {message}
        </p>
      )}

      {status !== 'loading' && (
        <button onClick={() => route(config.routes.login)} style={{
          padding: '12px 32px', borderRadius: 12,
          background: T.accent, color: T.accentInk,
          border: 'none', fontSize: 14, fontWeight: 700,
          fontFamily: T.font, cursor: 'pointer',
        }}>
          Go to login
        </button>
      )}
    </div>
  );
}
